export default __webpack_public_path__ + "static/media/logo.88b190d5.svg";